import classNames from "classnames";
import { IconProps } from "../types";
import { asIcon } from "../utils/library";

type IconTriangleProps = Pick<IconProps, "className">;

const Triangle = ({ className }: IconTriangleProps) => {
    const classes = classNames("chevronIcon", className);

    return (
        <svg
            className={classes}
            width="10"
            height="5"
            viewBox="0 0 10 5"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            data-testid="triangle-svg"
        >
            <path
                d="M0 0L5 5L10 0H0Z"
                fill="#545454"
                data-testid="triangle-path"
            />
        </svg>
    );
};

const IconTriangle = asIcon(Triangle);
export default IconTriangle;
